var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 54,
    viewBox: "0 0 40 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23041 39.5 20C39.5 21.9847 39.3269 23.5868 38.8447 25.2148C38.3614 26.8467 37.5608 28.5296 36.2754 30.667C33.6917 34.963 29.2284 40.9783 21.6445 51.9727C20.8501 53.1202 19.1498 53.1201 18.3555 51.9727C10.7716 40.9783 6.30827 34.963 3.72461 30.667C2.43916 28.5296 1.63856 26.8467 1.15527 25.2148C0.673127 23.5868 0.5 21.9847 0.5 20C0.500001 9.23041 9.23041 0.5 20 0.5Z",
    fill: "#25BB9D",
    stroke: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4141 11.167H22.1338C22.5446 11.1672 22.8276 11.5468 22.7344 11.9141L20.7539 17.8418L20.5342 18.5H26.6133C27.105 18.5 27.3766 19.013 27.1494 19.3945L27.1484 19.3965L18.9355 33.3301C18.8236 33.5198 18.6175 33.6338 18.3955 33.6338C17.9894 33.6338 17.7054 33.2654 17.7939 32.8984L19.9453 23.9844L20.0947 23.3672H13.9199C13.5368 23.367 13.2585 23.0374 13.3057 22.6865L13.3047 22.6855L14.7988 11.6875L14.7979 11.6865C14.8383 11.3967 15.0972 11.167 15.4141 11.167Z",
    fill: "white",
    stroke: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvMarker);
export default __webpack_public_path__ + "static/media/ev-marker.724310b50ca106137b73546b25249e7d.svg";
export { ForwardRef as ReactComponent };